import rematriculaRoutes from "./rematricula.js";
import alteracaoMatriculaRoutes from "./alteracaoMatricula.js";
import bibliotecaRoutes from "./biblioteca.js";
import agendaRoutes from "./agenda";
import aprendizagemRoutes from "./aprendizagem.js";
import atendimentoRoutes from "./atendimento.js";
import indicaiRoutes from "./indicai.js";
import notificacaoRoutes from "./notificacao.js";
import graduacaoRoutes from "./graduacao.js";
import responsavelRoutes from "./responsavel.js";
import auth from "../middleware/auth";

const NotFound = () => import("../components/Views/NotFound.vue");
const Login = () => import("../components/Views/Login.vue");
const Logoff = () => import("../components/Views/Logoff.vue");
const Boletos = () => import("../components/Views/Boletos.vue");
const LoginCorpore = () => import("../components/Views/LoginCorpore.vue");
const LoginInterno = () => import("../components/Views/LoginInterno.vue");
const LoginIntegradoOn = () =>
  import("../components/Views/LoginIntegradoOn.vue");

const mainRoutes = [
  {
    path: "/",
    component: LoginIntegradoOn,
    meta: {
      robots: "noindex",
      middleware: auth
    }
  },
  {
    path: "/login",
    component: Login,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login/:login/:path?",
    component: LoginInterno,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login-portal/:rota/:login/:path?",
    component: LoginInterno,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login-rematricula/:login/:rematriculaInterna?",
    component: LoginInterno,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login/:login/:path/:publico/:ambienteAtual?/:modalidadeAtual?",
    component: LoginInterno,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login-integrado-on",
    component: LoginIntegradoOn,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/login-corpore",
    component: LoginCorpore,
    name: "Login Corpore",
    meta: {
      robots: "noindex",
      middleware: auth,
      breadcrumb: [{ name: "Integrado", link: process.env.INTERNO_URL }]
    }
  },
  {
    path: "/logoff",
    component: Logoff,
    meta: {
      robots: "noindex"
    }
  },
  {
    path: "/boletos",
    component: Boletos,
    name: "Boletos",
    meta: {
      robots: "noindex",
      middleware: auth,
      breadcrumb: [{ name: "Integrado", link: process.env.INTERNO_URL }]
    }
  },
  {
    path: "*",
    component: NotFound,
    name: "404",
    meta: {
      robots: "noindex",
      breadcrumb: [{ name: "Integrado", link: process.env.INTERNO_URL }]
    }
  }
];

const routes = mainRoutes.concat(
  alteracaoMatriculaRoutes,
  rematriculaRoutes,
  bibliotecaRoutes,
  agendaRoutes,
  atendimentoRoutes,
  aprendizagemRoutes,
  indicaiRoutes,
  notificacaoRoutes,
  graduacaoRoutes,
  responsavelRoutes
);
export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js